let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2jMEV")).then(() => parcelRequire('7Bs3a'));